var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPwdIco16(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.96973 2C9.81026 2.00037 11.3026 3.49246 11.3027 5.33301V6H11.667C12.403 6.00037 12.9999 6.65117 13 7.4541V12.5449C13 13.348 12.4031 13.9996 11.667 14H4.33301C3.59681 13.9998 3 13.3481 3 12.5449V7.4541C3.00015 6.65108 3.5969 6.00023 4.33301 6H4.63672V5.33301C4.63685 3.49224 6.12888 2.00001 7.96973 2ZM7.99902 8C7.26283 8.0002 6.66602 8.59775 6.66602 9.33398C6.66618 9.82674 6.93437 10.2557 7.33203 10.4863V11.334C7.33238 11.7017 7.63124 11.9998 7.99902 12C8.367 12 8.66566 11.7019 8.66602 11.334V10.4863C9.06369 10.2557 9.33187 9.82675 9.33203 9.33398C9.33203 8.59766 8.73533 8.00006 7.99902 8ZM7.96973 3.33301C6.86524 3.33302 5.96985 4.22858 5.96973 5.33301V6H9.96973V5.33301C9.9696 4.2288 9.07391 3.33337 7.96973 3.33301Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPwdIco16);
export default __webpack_public_path__ + "static/media/Pwd_ico_16.271a354c94383190a6dde15246df3fc0.svg";
export { ForwardRef as ReactComponent };